import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-concessionaire',
  templateUrl: './maintenance-concessionaire.component.html',
  styleUrls: ['./maintenance-concessionaire.component.sass']
})
export class MaintenanceConcessionaireComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
